import type { ReactNode } from "react";
import { Provider } from "react-redux";

import { store } from "@/store";

/**
 * A thin wrapper around react-redux's `Provider` rather than using it
 * inline in `app/AppProviders.tsx` — kept symmetric with `QueryProvider` and
 * `ThemeProvider` so all three global providers are composed the same way,
 * and so store rehydration/persistence logic (if it's ever added) has one
 * obvious place to live without touching call sites.
 */
export function StoreProvider({ children }: { children: ReactNode }) {
  return <Provider store={store}>{children}</Provider>;
}
